import HeroComponent from '../components/hero';

export default class AboutController {

  constructor(options) {
    this.options = options;
    console.log('CONTACT CONTROLLER');

    this.contact_hero = new HeroComponent({
      elem          :'section.contact__hero',
    });

    // START MODALS

    $('.is-tip--date').click( () => {
      $('div.site__overlay').addClass('is-active');
      $('div.modal--contactTipDate .modal__content').removeClass('dn');
      $('div.modal--contactTipDate').addClass('is-active');
    });

    $('.is-tip--upc').click( () => {
      $('div.site__overlay').addClass('is-active');
      $('div.modal--contactTipUpc .modal__content').removeClass('dn');
      $('div.modal--contactTipUpc').addClass('is-active');
    });

    $('div.modal').click( (e) => {
      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal').removeClass('is-active');
        $('div.modal .modal__content').addClass('dn');
      }
    });

    // END MODALS

    $('.contact__hero__footer button').click( () => {
      const offset = $('#contactformlink').offset().top;
      $('html, body').animate({ scrollTop: `${offset}px` }, 500);
    });

    $('#contact__province').change( () => {
      if ($('#contact__province').val() !== '----') {
        const selected = $('#contact__province :selected').parent().attr('label');
        $('#contact__country').val(selected);
      }
    });

    let filesCount = 0;

    $('#contact_files_new').click( () => {
      $('#contact_files_new').parent().append($(`<div class="u-gridItem form-formItem form-formFile form-formItem"><input type="file" value="" name="data[InquiryUpload][${filesCount}][file]" id="contact__file${filesCount}"></div>`));
      filesCount += 1;
      console.log('CLICKED');
    });

    $('#contact-us-form').submit( (ev) => {
      ev.preventDefault();
      $('#contact-us-form .form__buttons input').prop('disabled', true);

      $('#contact-us-form > .form__block > .has-error').removeClass('has-error');

      let errors = false;
      let error = false;
      const errorClass = 'has-error';
      const requiredFields = {
        empty_field: ['#contact__firstname', '#contact__lastname', '#contact__address', '#contact__postal', '#contact__city', '#contact__postalcode', '#contact__comments'],
        empty_selection: ['#contact__salutation', '#contact__province', '#contact__topic'],
        bad_email: ['#contact__email'],
        checked: [],
        phone_number: ['#contact__dayphone', '#contact__evephone'],
      };

      $.each(requiredFields, (errorType, idList) => {
        $.each(idList, (ind, fieldID) => {
          error = false;

          if ( (errorType === 'empty_field') && ($(fieldID).val() === '') ) {
            error = true;
          }
          if ((errorType === 'empty_selection') && (($(fieldID).val() === '----') || $(fieldID).val() === null)) {
            error = true;
          }
          if (errorType === 'bad_email') {
            if ($(fieldID).val().search(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) === -1) {
              error = true;
            }
          }
          if (errorType === 'radio_chosen') {
            const field1 = $(fieldID[0]).is(':checked');
            const field2 = $(fieldID[1]).is(':checked');
            if ( (field1 && !field2) || (!field1 && field2) ) {
              error = false;
            } else {
              error = true;
            }
          }
          if ( (errorType === 'checked') && (!$(fieldID).is(':checked')) ) {
            error = true;
          }
          if ((errorType === 'phone_number') && ($(fieldID).val() !== '')) {
            let phone = $(fieldID).val();
            phone = phone.replace(/\(/g, '');
            phone = phone.replace(/\)/g, '');
            phone = phone.replace(/-/g, '');
            phone = phone.replace(/ /g, '');
            if (phone.search(/^[0-9]{10}$/) === -1) {
              error = true;
            } else {
              $(fieldID).val(phone);
            }
          }

          if (error) {
            if (errorType === 'radio_chosen') {
              $(fieldID[0]).parent().parent().addClass(errorClass);
            } else {
              $(fieldID).parent().addClass(errorClass);
            }
            errors = true;
          }
        });
      });

      if (!errors) {
        if ($('#contact__optin_newsletter').is(':checked')) {
          $('#contact__optin_newsletter2').removeAttr('disabled');
        }
        if ($('#contact__optin_facebook').is(':checked')) {
          $('#contact__optin_facebook2').removeAttr('disabled');
        }
        $.ajax({
          url: $('#contact-us-form').attr('action'),
          processData: false,
          contentType: false,
          data: new FormData($('#contact-us-form')[0]),
          enctype: $('#contact-us-form').attr('enctype'),
          method: 'post',
          success: (response) => {
            console.log(response);
            $('#contact-us-form .form__buttons input').prop('disabled', false);

            $('.form__block').addClass('is-complete');
            $('.ContactUsForm__success').addClass('is-active');

            setTimeout( () => {
              window.location.href += '#contactform';
              location.reload();
            }, 5000);
          },
        });
      }else{
        $('#contact-us-form .form__buttons input').prop('disabled', false);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/ContactController.js